import React from "react";
import "./Testimonial_Card.css";
import { IDS } from "../../../../utils/IDS";

const Testimonial_Card = ({ testimonial }) => {
  return (
    <div className="Testimonial_Card">
      <div className="quote_img_div">
        <img
          src="/assets/images/home/testimonials/quote.png"
          className="quote_img"
        />
      </div>
      <p className="review_text">{testimonial?.description || " "}
      </p>
      <div className="footer_div">
        <div className="profile_holder">
          <img
            src={IDS.IMG_URL + testimonial?.Testimonial?.image || " "}
            className="profile_img"
          />
          <p className="name_text">{testimonial?.name || " "} </p>
        </div>
      </div>
    </div>
  );
};

export default Testimonial_Card;
// import React from "react";
// import "./Testimonial_Card.css";

// const Testimonial_Card = ({ testimonial }) => {
//   return (
//     <div className="Testimonial_Card">
//       <div className="quote_img_div">
//         <img
//           src="/assets/images/home/testimonials/quote.png"
//           className="quote_img"
//         />
//       </div>
//       <p className="review_text">
//         One of the most valuable experiences I have had in my life. I have never
//         taken so much time to invest in myself & it has paid off. Physically,
//         emotionally, mentally & spiritually, I feel that I have grown.
//       </p>
//       <div className="footer_div">
//         <div className="profile_holder">
//           <img
//             src={
//               process.env.PUBLIC_URL +
//               "/assets/images/home/testimonials/img.png"
//             }
//             className="profile_img"
//           />
//           <p className="name_text">Akash Kumar</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Testimonial_Card;
